import { menus } from '@/utils/menus';

export default {
  searchMenus( state, options ) {
    state.menus = menus( options.user, options.routes );
  }
};
